/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量17
 * @export
 * @interface Col17
 */
export interface Col17 {
}

/**
 * Check if a given object implements the Col17 interface.
 */
export function instanceOfCol17(value: object): value is Col17 {
    return true;
}

export function Col17FromJSON(json: any): Col17 {
    return Col17FromJSONTyped(json, false);
}

export function Col17FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col17 {
    return json;
}

export function Col17ToJSON(json: any): Col17 {
    return Col17ToJSONTyped(json, false);
}

export function Col17ToJSONTyped(value?: Col17 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

